<div class="fixed-top custombg" style=" z-index: 100;">
    <div class="d-flex flex-column">
        <app-header #header></app-header>
        <app-breadcrumb></app-breadcrumb>
    </div>
</div>
<div class="wrapper">
    <form [formGroup]="AuditForm" #auditCreation="ngForm" autocomplete="disabled">
        <div *ngIf=!hideSummaryFields class="projectForm" id="summaryFields">
            <span class="auditerDetails pl-3 pb-2"> Project Tech Audit</span>
            <div class="row m-0">
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div>
                        <span class="labelName">Project Name <sup class="requiredStar">*</sup></span>
                    </div>
                    <div class="">
                        <input type="text" class="form-control" matInput placeholder="Select Project Name"
                            [formControl]="projectNameControl" [matAutocomplete]="autoProject"
                            (input)="filterProjects($event.target.value)" (focus)="filterProjects($event.target.value)" />
                        <mat-autocomplete #autoProject="matAutocomplete"
                            (optionSelected)="onProjectSelected($event.option.value)">
                            <mat-option *ngFor="let topic of filteredProjects" [value]="topic.projectName">
                                {{ topic.projectName }}
                            </mat-option>
                        </mat-autocomplete>
                        <div class="space">
                            <div *ngIf="AuditForm.get('projectId').invalid && AuditForm.get('projectId').errors && 
                                    (AuditForm.get('projectId').dirty || AuditForm.get('projectId').touched)">
                                <small class="text-danger" *ngIf="AuditForm.get('projectId').hasError('required')">
                                    Project name is required.
                                </small>
                                <small *ngIf="!AuditForm.get('projectId')?.errors?.serverError">
                                    {{AuditForm.get('projectId')?.errors?.serverError}}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div>
                        <span class="labelName">Project Manager <sup class="requiredStar">*</sup></span>
                    </div>
                    <div class="">
                        <!-- {{filteredProjectManagerNames | json}} -->
                        <input type="text" class="form-control" matInput placeholder="Select Project Manager"
                        [formControl]="managerNameControl" [matAutocomplete]="autoManager" (input) ="onprojectmanagerchange($event.target.value)" (focus)="filterManagers(managerNameControl.value)"/>
                        <mat-autocomplete #autoManager="matAutocomplete" (optionSelected)="onManagerSelected($event.option.value)">
                            <mat-option *ngFor="let manager of filteredProjectManagerNames"
                            [value]="manager.managerId">
                            {{ manager.managerName }}
                        </mat-option>
                        </mat-autocomplete>
                        <div class="space">
                            <div *ngIf="AuditForm.get('managerId').invalid && AuditForm.get('managerId').errors && 
                                (AuditForm.get('managerId').dirty || AuditForm.get('managerId').touched)">
                                <small class="text-danger" *ngIf="AuditForm.get('managerId').hasError('required')">
                                    Manager name is required.
                                </small>
                                <small *ngIf="!AuditForm.get('managerId')?.errors?.serverError">
                                    {{AuditForm.get('managerId')?.errors?.serverError}}</small>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div>
                        <span class="labelName">Delivery Manager <sup class="requiredStar">*</sup></span>
                    </div>
                    <div class="">
                        <input type="text" class="form-control" matInput placeholder="Select Delivery Manager"
                        [formControl]="deliveryManagerNameControl" [matAutocomplete]="autoDeliveryManager" (input) ="ondeliverymanagerchange($event.target.value)" (focus)="filterDeliveryManagers(deliveryManagerNameControl.value)" />
                        <mat-autocomplete #autoDeliveryManager="matAutocomplete" (optionSelected)="onDeliveryManagerSelected($event.option.value)">
                            <mat-option *ngFor="let topic of filteredDeliveryManagerNames"
                            [value]="topic.managerId">
                            {{ topic.managerName }}
                        </mat-option>
                        </mat-autocomplete>
                        <div class="space">
                            <div *ngIf="AuditForm.get('deliveryManagerId').invalid && AuditForm.get('deliveryManagerId').errors && 
                                (AuditForm.get('deliveryManagerId').dirty || AuditForm.get('deliveryManagerId').touched)">
                                <small class="text-danger" *ngIf="AuditForm.get('deliveryManagerId').hasError('required')">
                                    Delivery Manager name is required.
                                </small>
                                <small *ngIf="!AuditForm.get('deliveryManagerId')?.errors?.serverError">
                                    {{AuditForm.get('deliveryManagerId')?.errors?.serverError}}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div>
                        <span class="labelName">Portfolio Leader <sup class="requiredStar">*</sup></span>
                    </div>
                    <div class="">
                        <input type="text" class="form-control" matInput placeholder="Select Portfolio Leader"
                            [formControl]="portfolioLeaderControl" [matAutocomplete]="autoLeader" (input) ="onportfoliomanagerchange($event.target.value)" (focus)="filterLeaders(portfolioLeaderControl.value)"/>
                        <mat-autocomplete #autoLeader="matAutocomplete" (optionSelected)="onLeaderSelected($event.option.value)">
                            <mat-option *ngFor="let leader of filteredPortfolioLeaderNames"
                                [value]="leader.portfolioManagerId">
                                {{ leader.portfolioManagerName }}
                            </mat-option>
                        </mat-autocomplete>
                        <div class="space">
                            <div *ngIf="AuditForm.get('portfolioManagerId').invalid && AuditForm.get('portfolioManagerId').errors && 
                                        (AuditForm.get('portfolioManagerId').dirty || AuditForm.get('portfolioManagerId').touched)">
                                <small class="text-danger" *ngIf="AuditForm.get('portfolioManagerId').hasError('required')">
                                    Portfolio Leader is required.
                                </small>
                                <small *ngIf="!AuditForm.get('portfolioManagerId')?.errors?.serverError">
                                    {{ AuditForm.get('portfolioManagerId')?.errors?.serverError }}
                                </small>
                            </div>
                        </div>
                    </div>
                </div>                
                <!-- <div class="col-lg-4 col-md-6 col-sm-12">
                    <div>
                        <span class="labelName">Auditor Name <sup class="requiredStar">*</sup></span>
                    </div>
                    <div class="">
                        <input type="text" matInput class="form-control" [formControl]="AuditorNameControl"
                        placeholder="Select Auditor Name" [matAutocomplete]="autoAuditor"
                        (click)="getFilteredValues('')" (focus)="getFilteredValues('')" />
                    
                    <mat-autocomplete #autoAuditor="matAutocomplete" (optionSelected)="loadAuditors($event.option.value)">
                        <mat-option *ngFor="let auditor of filteredAuditors" [id]="auditor.userId" [value]="auditor.userName">
                            {{ auditor.userName }} ({{ auditor.userId }})
                        </mat-option>
                    </mat-autocomplete>
                        <div class="space">
                            <div *ngIf="AuditForm.get('auditorId').invalid && AuditForm.get('auditorId').errors && 
                                    (AuditForm.get('auditorId').dirty || AuditForm.get('auditorId').touched)">
                                <small class="text-danger" *ngIf="AuditForm.get('auditorId').hasError('required')">
                                    Auditor name is required.
                                </small>
                                <small *ngIf="!AuditForm.get('auditorId')?.errors?.serverError">
                                    {{AuditForm.get('auditorId')?.errors?.serverError}}</small>
                            </div>
                        </div>
                    </div>
                </div> -->
                <!-- <div class="col-lg-4 col-md-6 col-sm-12">
                    <div>
                        <span class="labelName">Sub-Auditor Name <sup class="requiredStar">*</sup></span>
                    </div>
                    <div class="mattselect">
                        <mat-select class="form-control" formControlName="subAuditorIds"
                            placeholder="Select Sub-Auditor" multiple
                            (openedChange)="onSubAuditorOpenChange(subAuditorSearch)"
                            (selectionChange)="changeOfSubAuditors($event)">
                            <input type="text" #subAuditorSearch (input)="onSubAuditorInputChange($event)"
                                autocomplete="off" matInput placeholder="Search" class="form-control" />
                            <mat-option *ngFor="let x of filteredSubAuditorsName"
                                [value]="x.userId" >{{ x.userName }} ({{ x.userId }})</mat-option>
                        </mat-select>
                        <div class="">
                            <span class="text-danger"
                                *ngIf="AuditForm.get('subAuditorIds')?.value != null && !AuditForm.get('subAuditorIds')?.valid">
                                Sub-Auditor name(s) is required.</span>
                            <span *ngIf="!AuditForm.get('subAuditorIds')?.errors?.serverError">
                                {{AuditForm.get('subAuditorIds')?.errors?.serverError}}</span>
                        </div>
                    </div>
                </div> -->
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div>
                        <span class="labelName">Technology
                            Stack <sup class="requiredStar">*</sup></span>
                    </div>
                    <div class="mattselect">
                        <mat-select formControlName="TechStackIds" class="form-control"
                            placeholder="Select Technology Stack" multiple>
                            <mat-option *ngFor="let topic of storeTechnology" [value]="topic.id">{{
                                topic.technologyStack }}</mat-option>
                        </mat-select>
                        <div class="space">
                            <div *ngIf="AuditForm.get('TechStackIds').invalid && AuditForm.get('TechStackIds').errors && 
                                (AuditForm.get('TechStackIds').dirty || AuditForm.get('TechStackIds').touched)">
                                <small class="text-danger" *ngIf="AuditForm.get('TechStackIds').hasError('required')">
                                    Tech stack is required.
                                </small>
                                <small *ngIf="!AuditForm.get('TechStackIds')?.errors?.serverError">
                                    {{AuditForm.get('techStackID')?.errors?.serverError}}</small>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div>
                        <span class="labelName">Start Date <sup class="requiredStar">*</sup></span>
                    </div>
                    <div class="startdate">
                        <mat-form-field subscriptSizing="dynamic" appearance="outline">
                            <input type="datetime" matInput [matDatepicker]="picker" [min]="today" placeholder="DD-MM-YYYY" formControlName="dateControl" readonly>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker [matDatepickerFilter]="disablePastDates"></mat-datepicker>
                        </mat-form-field>
                        <div class="space">
                            <div class="text-danger" *ngIf=" AuditForm.get('dateControl').hasError('required') && (AuditForm.get('dateControl').touched || AuditForm.get('dateControl').dirty)">Required</div>
                        </div>
                    </div>                     
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12">
                    <div>
                        <span class="labelName">End Date</span>
                    </div>
                    <div class="enddate">
                        <mat-form-field subscriptSizing="dynamic" appearance="outline" [disabled]="true">
                            <input type="text" matInput placeholder="DD-MM-YYYY" formControlName="endDateControl" [disabled]="true">
                            <mat-datepicker-toggle matSuffix [for]="picker"[disabled]="true" ></mat-datepicker-toggle>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>



        <div class="projectForms" style="justify-content:center">
            <div *ngIf="auditId != undefined && auditId > 0" class="projectSummary" [formGroup]="AuditGeneralForm"
                style="width:100%">
                <span id="textTitle">Audit Additional Details</span>
                <div class="projectForms">
                    <div class="">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div>
                                        <span class="labelName">Team Size<sup class="requiredStar"
                                                *ngIf="auditId > 0">*</sup></span>
                                    </div>
                                    <div class="">
                                        <input class="form-control" placeholder="Enter Team Size" style="width: 100%;"
                                            [required]="auditId > 0" formControlName="teamSize" type="number" min="1">
                                    </div>
                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div>
                                        <span class="labelName">Last Audit Date<sup class="requiredStar"
                                                *ngIf="auditId > 0">*</sup></span>
                                    </div>
                                    <div class="">
                                        <input type="date" class="form-control" style="width: 100%;"
                                            [required]="auditId > 0" formControlName="timeForLastAudit">
                                    </div>

                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div>
                                        <span class="labelName">Code Review Frequency and Process<sup
                                                class="requiredStar" *ngIf="auditId > 0">*</sup></span>
                                    </div>
                                    <div class="">
                                        <input class="form-control"
                                            placeholder="Enter Code Review Frequency and Process" style="width: 100%;"
                                            [required]="auditId > 0" formControlName="codeReviewFrequencyAndProcess">
                                    </div>

                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div>
                                        <span class="labelName">Scope<sup class="requiredStar"
                                                *ngIf="auditId > 0">*</sup></span>
                                    </div>
                                    <div class="">
                                        <input class="form-control" placeholder="Enter Scope" style="width: 100%;"
                                            [required]="auditId > 0" formControlName="scopeOfAudit">
                                    </div>

                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div>
                                        <span class="labelName">Earlier Audit Report Reviewed and Approved<sup
                                                class="requiredStar" *ngIf="auditId > 0">*</sup></span>
                                    </div>
                                    <div class="mattselect">
                                        <mat-select class="form-control" style="width: 100%;" [required]="auditId > 0"
                                            formControlName="earlierAuditReportReviewAndApprovedBy" placeholder="Select Audit
                                            Report">
                                            <mat-option *ngFor="let topic of storePointofContactsNames"
                                                [value]="topic.userId">{{ topic.userName }}</mat-option>
                                        </mat-select>
                                    </div>

                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div>
                                        <span class="labelName">Delivery Model<sup class="requiredStar"
                                                *ngIf="auditId > 0">*</sup></span>
                                    </div>
                                    <div class="">
                                        <input class="form-control" placeholder="Enter Delivery Model"
                                            style="width: 100%;" [required]="auditId > 0"
                                            formControlName="deliveryModel">
                                    </div>

                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div>
                                        <span class="labelName">Development Methodology<sup class="requiredStar"
                                                *ngIf="auditId > 0">*</sup></span>
                                    </div>
                                    <div class="">
                                        <select class="form-control" style="width: 100%;" [required]="auditId > 0"
                                            formControlName="developmentMethodology">
                                            <option value=0 disabled selected hidden>Select Development Methodology
                                            </option>
                                            <option *ngFor="let dev of developmentMethodologies" [value]="dev.id">
                                                {{ dev.description }}</option>
                                        </select>
                                    </div>

                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div>
                                        <span class="labelName">Comments<sup class="requiredStar"
                                                *ngIf="auditId > 0">*</sup></span>
                                    </div>
                                    <div class="">
                                        <input class="form-control" placeholder="Enter Comments" style="width: 100%;"
                                            [required]="auditId > 0" formControlName="deliveryModel">
                                    </div>

                                </div>
                                <div class="col-lg-4 col-md-6 col-sm-12">
                                    <div>
                                        <span class="labelName">Audit Frequency<sup class="requiredStar"
                                                *ngIf="auditId > 0">*</sup></span>
                                    </div>
                                    <div class="">
                                        <select class="form-control" [required]="auditId > 0"
                                            formControlName="auditFrequency">
                                            <option value=0 disabled selected hidden>Select Audit Frequency</option>
                                            <option *ngFor="let item of auditFreqOptions" [value]="item.id">
                                                {{ item.description }}</option>
                                        </select>
                                    </div>

                                </div>
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">
                            </div>
                            <div class="row">

                            </div>
                        </div>
                    </div>
                </div>

            </div>


            <div *ngIf="auditId" class="projectSummary" [formGroup]="AuditPOCForm" style="width:100%">
                <span id="textTitle">Audit Team Contact</span>
                <div class="projectForms">
                    <div class="row m-0">
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div>
                                <span class="labelName">Functional Overview<sup class="requiredStar"
                                        *ngIf="auditId > 0">*</sup></span>
                            </div>
                            <div class="mattselect">
                                <input type="hidden" formControlName="overviewPOCTypeId" value="0" />
                                <mat-select class="form-control" style="width: 100%;" formControlName="overviewPOCId"
                                    [required]="auditId > 0" placeholder="Select Functional Overview">
                                    <mat-option value=0 disabled selected hidden>Select Point of Contact</mat-option>
                                    <mat-option *ngFor="let topic of storePointofContactsNames"
                                        [value]="topic.userId">{{
                                        topic.userName }}</mat-option>
                                </mat-select>
                            </div>

                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div>
                                <span class="labelName">Self Audit<sup class="requiredStar"
                                        *ngIf="auditId > 0">*</sup></span>
                            </div>
                            <div class="mattselect">
                                <input type="hidden" formControlName="demoPOCTypeId" value="0" />
                                <mat-select class="form-control" style="width: 100%;" formControlName="demoPOCId"
                                    [required]="auditId > 0" placeholder="Select Self Audit">
                                    <mat-option value=0 disabled selected hidden>Select Point of Contact</mat-option>
                                    <mat-option *ngFor="let topic of storePointofContactsNames"
                                        [value]="topic.userId">{{
                                        topic.userName }}</mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div>
                                <span class="labelName">Functional Overview<sup class="requiredStar"
                                        *ngIf="auditId > 0">*</sup></span>
                            </div>

                            <div class="mattselect">
                                <input type="hidden" formControlName="architecturePOCTypeId" value="0" />
                                <mat-select class="form-control" style="width: 100%;"
                                    formControlName="architecturePOCId" [required]="auditId > 0"
                                    placeholder="Select Architecture">
                                    <mat-option value=0 disabled selected hidden>Select Point of Contact</mat-option>
                                    <mat-option *ngFor="let topic of storePointofContactsNames"
                                        [value]="topic.userId">{{
                                        topic.userName }}</mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div>
                                <span class="labelName">Design Walkthrough<sup class="requiredStar"
                                        *ngIf="auditId > 0">*</sup></span>
                            </div>
                            <div class="mattselect">
                                <input type="hidden" formControlName="designAppPOCTypeId" value="0" />
                                <mat-select class="form-control" style="width: 100%;" formControlName="designAppPOCId"
                                    [required]="auditId > 0" placeholder="Select Design Walkthrough">
                                    <mat-option value=0 disabled selected hidden>Select Point of Contact</mat-option>
                                    <mat-option *ngFor="let topic of storePointofContactsNames"
                                        [value]="topic.userId">{{
                                        topic.userName }}</mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div>
                                <span class="labelName">Technical Support<sup class="requiredStar"
                                        *ngIf="auditId > 0">*</sup></span>
                            </div>
                            <div class="mattselect">
                                <input type="hidden" formControlName="techQueryPOCTypeId" value="0" />
                                <mat-select class="form-control" style="width: 100%;" formControlName="techQueryPOCId"
                                    [required]="auditId > 0" placeholder="Select Technical Support">
                                    <mat-option value=0 disabled selected hidden>Select Point of Contact</mat-option>
                                    <mat-option *ngFor="let topic of storePointofContactsNames" [value]="topic.userId">
                                        {{ topic.userName }}</mat-option>
                                </mat-select>
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-6 col-sm-12">
                            <div>
                                <span class="labelName">Non-Technical Support<sup class="requiredStar"
                                        *ngIf="auditId > 0">*</sup></span>
                            </div>
                            <div class="mattselect">
                                <input type="hidden" formControlName="nonTechQueryPOCTypeId" value="0" />
                                <mat-select class="form-control" style="width: 100%;"
                                    formControlName="nonTechQueryPOCId" [required]="auditId > 0"
                                    placeholder="Select Non-Technical Support">
                                    <mat-option value=0 disabled selected hidden>Select Point of Contact</mat-option>
                                    <mat-option *ngFor="let topic of storePointofContactsNames"
                                        [value]="topic.userId">{{
                                        topic.userName }}</mat-option>
                                </mat-select>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="auditId != undefined && auditId > 0" class="projectSummary" [formGroup]="AuditGeneralForm">
            <div class="auditerDetails">Audit Documentation</div>
            <div class="row m-0">
                <div class="col-6 col-lg-4">
                    <div>
                        <span class="labelName">Provide the Path for Documentation<sup class="requiredStar"
                                *ngIf="auditId > 0">*</sup></span>
                    </div>
                    <div class="">
                        <input class="form-control" type="text" id="documentationPath"
                            formControlName="projectDocumentationPath" placeholder="Enter the path for documentation" />
                    </div>
                </div>
            </div>
        </div>

        <div class="auditbtn" *ngIf="hasHideOrDisabled">
            <button class="custom_btn inverted_btn_base mr-3" (click)="navigateToProjectOverview()">Cancel</button>
            <button class="custom_btn primary_btn_base" (click)="AuditCreateDetails()" type="submit">Save</button>
        </div>

        <div class="auditbtn" *ngIf="!hasHideOrDisabled" style="float: left;">
            <button class="custom_btn inverted_btn_base mr-3" (click)="navigateToProjectDisplay()">Cancel</button>
            <button class="custom_btn primary_btn_base" (click)="AuditCreateDetails()" type="submit">Save</button>
        </div>

    </form>
</div>